import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AuthEffect } from './store/auth/auth.effects';
import { reducers } from './store';
import { TokenInterceptor } from './interceptor/token.interceptor';
import { AuthAdminEffect } from './store/auth-admin/auth-admin.effects';
import { ErrorInterceptor } from './interceptor/error.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SetPasswordEffect } from './store/set-password/effects';
import { LoginCredentialsEffect } from './store/login/effects';
import { LoginCodeEffect } from './store/login-code/effects';
import { ChangePasswordEffect } from './store/change-password/effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([
      AuthEffect,
      AuthAdminEffect,
      SetPasswordEffect,
      ChangePasswordEffect,
      LoginCredentialsEffect,
      LoginCodeEffect,
    ]),
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {}
